import  { useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import CreateCustomer from "./CreateCustomerForm";
import Modal from "../Reusable/Modal";
import Form from "../../layouts/Form";
import OrderForm from "./OrderForm";

const CreateOrder = (props: any) => {
  const { handleCreate, isLoading, handleCreateCustomer, createCustomerLoading, defaultBranch } = props;
  const [openAddReceiverPopup, setOpenAddReceiverPopup] = useState(false)
  const [openAddSenderPopup, setOpenAddSenderPopup] = useState(false)

 

 console.log(defaultBranch, "default branch")
  const {
    control,
    register,
    handleSubmit,
    getValues,
    reset,
    watch,
    setError,
    setValue,
    clearErrors,
    formState: { errors }
  } = useForm({
    defaultValues: async () => {
      return {
        vendor: null,
        receiver: null,
        sender: null,
        pickup_branch: defaultBranch,
        destination: null,
        cod: 0,
        order_value: 0,
        service_type: null,
        payment_method: null,
        reference_date: null,
        reference_type: null,
        reference_number: null,
        note: "",
        order_items: [
          {
            package_type: null,
            weight: 1,
            piece: 1
          }
        ]
      }
    }
  });


  const { fields, append, remove } = useFieldArray({
    control,
    name: "order_items"
  });


  return (
    <>
      <Form
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Create"}
        isLoading={isLoading}
      >
        <OrderForm
          clearErrors={clearErrors}
          errors={errors}
          register={register}
          setValue={setValue}
          getValues={getValues}
          watch={watch}
          openAddReceiverPopup={openAddReceiverPopup}
          setOpenAddReceiverPopup={setOpenAddReceiverPopup}
          openAddSenderPopup={openAddSenderPopup}
          setOpenAddSenderPopup={setOpenAddSenderPopup}
          fields={fields}
          append={append}
          remove={remove}
        />
      </Form>

      <Modal
        isOpen={openAddReceiverPopup}
        setIsOpen={setOpenAddReceiverPopup}
        title={"Craeate Receiver"}
        children={<>
          <CreateCustomer
            handleCreate={handleCreateCustomer}
            isLoading={createCustomerLoading}
          />
        </>} />
      <Modal
        isOpen={openAddSenderPopup}
        setIsOpen={setOpenAddSenderPopup}
        title={"Create Sender"}
        children={<>
          <CreateCustomer
            handleCreate={handleCreateCustomer}
            isLoading={createCustomerLoading}
          />
        </>} />
    </>

  )
};

export default CreateOrder;
